import { GrLocation } from 'react-icons/gr'
import { useTranslation } from 'next-i18next'
import React, { useRef, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './ProjectFormLocationAutoComplete.module.scss'
import { projectFormLocationTextSelector, setProjectFormItemValue } from 'src/features'

const ProjectFormLocationAutoComplete: React.FC = () => {
  const { t } = useTranslation()
  const autoCompleteRef = useRef(null)
  const inputRef = useRef(null)
  const dispatch = useAppDispatch()
  const locationText = useAppSelector(projectFormLocationTextSelector)

  useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current)

    autoCompleteRef.current.addListener('place_changed', async function () {
      const values = await autoCompleteRef.current.getPlace()
      const { geometry: { location }, formatted_address } = values
      dispatch(setProjectFormItemValue({ key: 'latitude', value: location.lat() }))
      dispatch(setProjectFormItemValue({ key: 'longitude', value: location.lng() }))
      dispatch(setProjectFormItemValue({ key: 'locationText', value: formatted_address }))
    })
  }, [dispatch])

  return (
    <div className={styles.content}>
      <div className={styles.inputContainer}>
        <input
          type='text'
          ref={inputRef}
          className={styles.input}
          value={locationText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(setProjectFormItemValue({ key: 'locationText', value: e.target.value }))
          }}
          placeholder={t('Projects.LocationPlaceholder')}
        />
        <GrLocation className={styles.icon} size={'23px'}/>
      </div>
    </div>
  )
}

export default ProjectFormLocationAutoComplete
